<form [formGroup]="cartForm">
    <checkout-quote-detail
        (simChoice)="onSimChoice($event)"
        [quoteIndex]="0"
        [cartForm]="cartForm"
        [isSubmitted]="isSubmitted"
        [isMobile]="isMobileMQ"
    />
    @if (hasSecondQuoteFai) {
        <!-- Bloc visible uniquement avec une offre FAI dans le second parcours -->
        <h3 class="is-summary-title is-level-3 has-text-weight-semibold pb-1 pt-2">Mon offre fixe</h3>
        <checkout-quote-detail
            [quoteIndex]="1"
            [cartForm]="cartForm"
            [isSubmitted]="isSubmitted"
            [isMobile]="isMobileMQ"
        />
    } @else {
        <!-- Block panier mixte - si categorie dispo -->
        @if (suggestMixedCart) {
            <div checkoutCy="mixte_block">
                @if (isFai) {
                    <checkout-mobile-block
                        (simChoice)="onSimChoice($event)"
                        [cartForm]="cartForm"
                        [isSubmitted]="isSubmitted"
                        [isMobile]="isMobileMQ"
                    />
                }
                @if (isSimo || isSowo) {
                    <checkout-fai-block
                        [cartForm]="cartForm"
                        [isSubmitted]="isSubmitted"
                        [isMobile]="isMobileMQ"
                        [redirectUrl]="widgetRedirectUrl"
                        [focus]="widgetFocus"
                    />
                }
            </div>
        }
    }
</form>
